import React from "react";
import type { Section as SectionType } from "@ps-bridge/models/core/dataContracts";
import type { IOts } from "@ps-bridge/interop";
import type { Ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import SectionCardPanel, {
  type SectionCardContentPhase,
  type SectionCardPhase,
} from "@view/panels/document/review/SectionCard.panel";
import { readOptionString } from "@utils/readOptionString";
import { renderMarkdownHtml } from "@utils/markdown";

export type SectionCardProps = {
  section: SectionType;
  active: boolean;
  onPressIo: IOts<Ok>;
};

const SectionCard: React.FC<SectionCardProps> = ({ section, active, onPressIo }) => {
  const phase: SectionCardPhase = active ? "active" : "inactive";
  const contentValue = readOptionString(section.section_contents);
  const contentPhase: SectionCardContentPhase =
    contentValue.trim().length > 0 ? "content" : "placeholder";
  const contentHtml = renderMarkdownHtml(contentValue);
  const onPress: () => Ok = () => IO.run(onPressIo);

  return (
    <SectionCardPanel
      title={section.metadata.name}
      contentHtml={contentHtml}
      phase={phase}
      contentPhase={contentPhase}
      onPress={onPress}
    />
  );
};

export default React.memo(SectionCard, (prevProps, nextProps) => {
  return (
    prevProps.active === nextProps.active &&
    prevProps.section === nextProps.section
  );
});
